import { useState } from "react";
import { HeartToggleButton } from "./heart-toggle-button";
import { SaveColorDropdown } from "./save-color-dropdown";
import { useSaveColor } from "../../save-color";
import {
  useSavedColors,
  useCmsSaveColor,
  useCmsDeleteColor,
} from "../../../js/api/my-saved-colors/get-saved-colors";
import { TrendingBadge } from "../my-saved-colors/trending-badge";

export function SaveButtons({ basketAction, collectionAction, removeFromCollectionAction }) {
  const [isSpinnerVisible, setIsSpinnerVisible] = useState(false);
  const {
    saveColorUrl,
    saveColorLabel,
    removeColorUrl,
    removeColorLabel,
    colorCode,
    isTrending,
  } = useSaveColor();
  const { data, isLoading, isError } = useSavedColors();
  const isSaveFunctionalityReady = !isLoading && !isError;
  const saveCmsColorMutation = useCmsSaveColor();
  const deleteCmsColorMutation = useCmsDeleteColor();
  const savedColors = data?.items || [];
  const savedColor = savedColors.find(
    (color) => color?.colourCode === colorCode
  );
  const isColorSaved = !!savedColor;

  const toggleClickHandler = () => {
    setIsSpinnerVisible(true);
    if (isColorSaved) {
      deleteCmsColorMutation.mutateAsync({
        url: removeColorUrl,
        successHandler: () => setIsSpinnerVisible(false),
        errorHandler: () => setIsSpinnerVisible(false),
      });
    } else {
      saveCmsColorMutation.mutateAsync({
        url: saveColorUrl,
        successHandler: () => setIsSpinnerVisible(false),
        errorHandler: () => setIsSpinnerVisible(false),
      });
    }
  };
  const saveAction = isSaveFunctionalityReady
    ? {
        label: isColorSaved ? removeColorLabel : saveColorLabel,
        clickHandler: () => toggleClickHandler(),
        disabled: isSpinnerVisible,
      }
    : null;
    const actions = [basketAction, collectionAction, removeFromCollectionAction, saveAction].filter(
    (action) => action
  );

  return (
    <div>
      {isSaveFunctionalityReady && (
        <HeartToggleButton
          isSaved={isColorSaved}
          isLoading={isSpinnerVisible}
          disabled={isSpinnerVisible}
          toggleClickHandler={toggleClickHandler}
        />
      )}

      <SaveColorDropdown actions={actions} />
      {!!isTrending && <TrendingBadge />}
    </div>
  );
}
